import React, { Component } from "react";

import { Box } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import {Picker} from "../Utils/Picker";

class InsuranceSection extends Component {
  render() {

    let insuranceInfo = (this.props.rental.customer && this.props.rental.customer.id) ? this.props.rental.customer.insurance_info : [];

    let insuranceInfoObjects = insuranceInfo && insuranceInfo.length > 0 ? insuranceInfo.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

    const onInsuranceChange = e => {
      let insuranceInfo = insuranceInfoObjects[e.target.value]
      const toUpdate = {
        target: {
          name: e.target.name,
          value: insuranceInfo
        }
      }
      this.props.onChange(toUpdate);
      // now handle changing all the licence information
      if(insuranceInfo) {
        let otherDataToChange = {
          policy_name: insuranceInfo.policy_name,
          policy_number: insuranceInfo.policy_number,
          insurer: insuranceInfo.insurer,
          insurance_excess: insuranceInfo.insurance_excess,
          insurance_company_email: insuranceInfo.insurance_email,
          insurance_expiry: insuranceInfo.insurance_expiry_date,
          insurance_copy_saved: insuranceInfo.insurance_copy_saved
        }
        this.props.triggerChange(otherDataToChange);
      }
    }


    return (
      <Box>
        <Heading>Insurance</Heading>
        <Columns>
          <Columns.Column>
            <Picker
                options={{results: insuranceInfo}}
                label={"Insurance Policy"}
                value={this.props.rental.insurance_policy}
                blank={true}
                name={"insurance_policy"}
                optionField={"policy_number"}
                onChange={onInsuranceChange}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Policy Number</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="policy_number"
                  onChange={this.props.onChange}
                  value={this.props.rental.policy_number}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Policy Name</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="policy_name"
                  onChange={this.props.onChange}
                  value={this.props.rental.policy_name}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Insurer</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="insurer"
                  onChange={this.props.onChange}
                  value={this.props.rental.insurer}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
            <Columns.Column>
            <Form.Field>
              <Form.Label>Insurance Email</Form.Label>
              <Form.Control>
                <Form.Input
                  type="text"
                  name="insurance_company_email"
                  onChange={this.props.onChange}
                  value={this.props.rental.insurance_company_email}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Control>
              <Form.Field>
                <Form.Label>Insurance Excess</Form.Label>
                <Form.Input
                  type="number"
                  name="insurance_excess"
                  onChange={this.props.onChange}
                  value={this.props.rental.insurance_excess}
                  required
                />
              </Form.Field>
            </Form.Control>
          </Columns.Column>
          <Columns.Column>
            <Form.Control>
              <Form.Field>
                <Form.Label>Insurance Expiry</Form.Label>
                <Form.Input
                  type="date"
                  name="insurance_expiry"
                  onChange={this.props.onChange}
                  value={this.props.rental.insurance_expiry}
                  required
                />
              </Form.Field>
            </Form.Control>
          </Columns.Column>
          <Columns.Column>
            <Form.Control>
              <Form.Field>
                <Form.Label>Insurance Copy Saved</Form.Label>
                <Form.Checkbox
                  name="insurance_copy_saved"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.insurance_copy_saved}
                  required
                />
              </Form.Field>
            </Form.Control>
          </Columns.Column>
        </Columns>
      </Box>
    );
  }
}

export default InsuranceSection;
